export class pnlCalculatorModel {
setValue(res){
if(res){
}
}
}
